import React from 'react';
import {connect} from 'react-redux'
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Button, Col, Modal, Row } from "antd";
import 'antd/lib/modal/style/css';
import {Field, reduxForm} from "redux-form";
import {CreateFileField, CreatePasswordField, CreateTextField} from "../../helpers/InputCreator";
import {required} from "../../helpers/validations";
import languages from "../../language/languages";
import getWebServiceUserInfo from "../../actions/getWebServiceUserInfo";
import {LockOutlined} from "@ant-design/icons";


class AdminWebservicesModal extends React.Component {

  state = {formFile: []};

  componentDidMount()
  {
    this.props.getWebServiceUserInfo(this.props.entryId);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if(this.props.initialValues !== prevProps.initialValues) {
      this.props.initialize(this.props.initialValues);
    }
  }

  onSubmit = (formValues) => {
    let file = this.state.formFile[0] === undefined ? null : this.state.formFile[0].file;
    this.props.onSubmit(formValues, file);
  };

  handleOnDrop = (newImageFile, onChange) => {
    const formFile = {
      file: newImageFile[0],
      name: newImageFile[0].name,
      preview: URL.createObjectURL(newImageFile[0]),
      size: newImageFile[0].size
    };

    this.setState({formFile: [formFile]}, () => onChange(formFile));
  };

  render() {
    return (
      <Modal centered
        visible={this.props.modalType !== null} width={720} {...this.props.modalProps}>
          <Form onSubmit={this.props.handleSubmit(this.onSubmit)}>
            <Row gutter={16}>
              <Col xs={24} md={12}>
                <Field label={languages[this.props.language].select_cert}
                       name="avatar"
                       accept={".cer"}
                       component={CreateFileField}
                       handleOnDrop={this.handleOnDrop}
                       type='file'
                       formFile={this.state.formFile}
                       multiple={false}
                />
              </Col>
              <Col xs={24} md={12}>
                <Field label={languages[this.props.language].ip_column}
                       name="ip"
                       disabled={this.props.disabledFields}
                       component={CreateTextField}
                       validate={required}
                       placeholder={languages[this.props.language].ip_column}
                       hasFeedback/>
                <Field label={languages[this.props.language].password}
                       name="password"
                       size={'large'}
                       className={'mb-10'}
                       prefix={<LockOutlined className={'icon-font'} />}
                       component={CreatePasswordField}
                       validate={required}
                       placeholder={languages[this.props.language].password}
                       hasFeedback/>

              </Col>
            </Row>
            <Row>
              <Button htmlType={'submit'} type={'primary'}>{this.props.btn}</Button>
            </Row>
          </Form>
      </Modal>
    )
  }

}

function mapStateToProps(state) {
  return {
    language: state.auth.language,
    initialValues: state.users.selectedEntry
  }
}

export default connect(mapStateToProps, {getWebServiceUserInfo})(reduxForm({form: 'admin_webservices_form'})(AdminWebservicesModal));
